import React from 'react';

import { SelectorListItem } from '../../../../../types/store/selector-list-item';

interface IAddToCartSelectorProps {
  items: SelectorListItem[];
  handlerSelect: (value: string | number) => void;
}

const AddToCartSelector = ({
  items,
  handlerSelect,
}: IAddToCartSelectorProps) => {
  return (
    <ul
      className='store__drm-list'
      data-type='add-to-cart-selector'
      data-drm-selector
    >
      {items.map(({ name, value, price }) => (
        <li
          key={value}
          className='store__drm-item'
          onClick={() => handlerSelect(value)}
        >
          <span>{name}</span>
          {price && <span className='store__drm-price'>{price}</span>}
        </li>
      ))}
    </ul>
  );
};

export default AddToCartSelector;
